module.exports = __webpack_public_path__ + "img/pic01.337f9f49.jpg";